module.exports = __webpack_public_path__ + "img/youtube.0af013c2.svg";